let dataConfig = {
  id: 'crossword',
  mainImage: {
    imagePath: 'games/page021_game4/img/bcg.png',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
    height: 1080,
  },
  withoutCheck: false,
  inputWidth: 50,
  cssStyle: {
    top: '330px',
    transform: 'scale(1.7, 1.7)',
  },
  imgW: '200px',
  imgH: '200px',
  posAbsolute: true,
  crossword: [
    {
      pass: 'LAMPA',
      txt: ' ',
      indx: 3,
      sel: 0,
    },
    {
      pass: 'APARAT',
      txt: ' ',
      indx: 1,
      sel: 2,
    },
    {
      pass: 'MAPA',
      txt: ' ',
      indx: 1,
      sel: 2,
    },
    {
      pass: 'BUTY',
      txt: ' ',
      indx: 1,
      sel: 2,
    },
    {
      pass: 'ROWER',
      txt: ' ',
      indx: 2,
      sel: 1,
    },
    {
      pass: 'LUPA',
      txt: ' ',
      indx: 1,
      sel: 2,
    },
  ],
};

export default dataConfig;
